import { CaptureJob } from "@components/ChartCapture/types";

export const captureJobId = (job: CaptureJob): string =>
  job.kind === "goal" ? `goal:${job.goal.id}` : `target:${job.target.id}`;
